/* Clore subscription gift cart controller. */
(function(){
  if (window.__cloreSlideCartInitialized) return;
  window.__cloreSlideCartInitialized = true;

  var drawer = document.querySelectorAll('#clore-slide-cart'); drawer = drawer[drawer.length - 1];
  if (!drawer) return;
  var body = drawer.querySelector('[data-clore-cart-body]');
  var footer = drawer.querySelector('[data-clore-cart-footer]');
  var subtotal = drawer.querySelector('[data-clore-cart-subtotal]');
  var notice = drawer.querySelector('[data-clore-cart-notice]');
  var panel = drawer.querySelector('.clore-slide-cart__panel');
  var checkout = drawer.querySelector('[data-clore-cart-checkout]');

  function money(cents){
    cents = Math.round(Number(cents) || 0);
    var dollars = cents / 100;
    var options = {style:'currency', currency:'USD'};
    if (Math.abs(cents) % 100 === 0) {
      options.minimumFractionDigits = 0;
      options.maximumFractionDigits = 0;
    }
    return new Intl.NumberFormat('en-US', options).format(dollars);
  }

  function showNotice(message){
    if (!notice) return;
    notice.textContent = message;
    notice.hidden = !message;
    if (message) setTimeout(function(){ notice.hidden = true; }, 4200);
  }

  function ensureCheckoutNodes(){
    if (!footer && panel) {
      footer = document.createElement('footer');
      footer.className = 'clore-slide-cart__footer';
      footer.setAttribute('data-clore-cart-footer', '');
      footer.innerHTML = '<div class="clore-slide-cart__subtotal-row"><span>Subtotal</span><strong data-clore-cart-subtotal>$0.00</strong></div><a href="/checkout" target="_self" class="clore-slide-cart__checkout" data-clore-cart-checkout>Checkout</a><button type="button" class="clore-slide-cart__continue" data-clore-cart-close>Continue Shopping</button>';
      panel.appendChild(footer);
    }
    if (!subtotal && footer) subtotal = footer.querySelector('[data-clore-cart-subtotal]');
    if (!checkout && footer) checkout = footer.querySelector('[data-clore-cart-checkout]');
    if (!checkout && footer) {
      checkout = document.createElement('a');
      checkout.href = '/checkout';
      checkout.className = 'clore-slide-cart__checkout';
      checkout.setAttribute('data-clore-cart-checkout', '');
      checkout.setAttribute('target', '_self');
      checkout.textContent = 'Checkout';
      var continueButton = footer.querySelector('[data-clore-cart-close]');
      footer.insertBefore(checkout, continueButton || null);
    }
  }

  function forceCheckoutVisible(hasItems){
    ensureCheckoutNodes();
    drawer.classList.toggle('has-items', hasItems !== false);
    if (footer) {
      footer.hidden = false;
      footer.removeAttribute('hidden');
      footer.style.display = 'block';
      footer.style.visibility = 'visible';
      footer.style.opacity = '1';
    }
    if (checkout) {
      checkout.hidden = false;
      checkout.removeAttribute('hidden');
      checkout.style.display = 'flex';
      checkout.style.visibility = 'visible';
      checkout.style.opacity = '1';
      checkout.setAttribute('href', checkoutUrl());
      checkout.setAttribute('target', '_self');
      checkout.setAttribute('aria-hidden', 'false');
      checkout.textContent = checkout.textContent.trim() || 'Checkout';
    }
  }

  function openDrawer(options){
    options = options || {};
    if (options.loading && body) body.innerHTML = '<div class="clore-slide-cart__loading">Loading cart...</div>';
    forceCheckoutVisible(options.hasItems);
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    document.body.classList.add('clore-slide-cart-open');
    setTimeout(function(){ if(panel) panel.focus(); }, 30);
  }

  function closeDrawer(){
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    document.body.classList.remove('clore-slide-cart-open');
  }

  function fetchCart(){
    return fetch('/cart.js?t=' + Date.now(), {headers:{'Accept':'application/json'}, credentials:'same-origin', cache:'no-store'}).then(function(r){
      if (!r.ok) throw new Error('Cart unavailable');
      return r.json();
    });
  }


  var cloreKitUrlOverrides = {
    '49043956138219': '/products/5-gallons-hand-sprayer-1',
    '48073524510955': '/products/5-gallons-hand-sprayer-1',
    '49287081066731': '/products/clore-ready-to-use-jug-5-gallons',
    '49287081099499': '/products/clore-ready-to-use-jug-5-gallons',
    '48039276708075': '/products/clore-ready-to-use-kit-10-gallons',
    '48039276740843': '/products/clore-ready-to-use-kit-10-gallons',
    '48039276773611': '/products/clore-ready-to-use-kit-10-gallons',
    '48039266648299': '/products/clore-ready-to-use-kit-20-gallons',
    '48039266681067': '/products/clore-ready-to-use-kit-20-gallons',
    '48039266713835': '/products/clore-ready-to-use-kit-20-gallons',
    '48035377348843': '/products/clore-concentrate-mix-kit-30-gallons',
    '48035377381611': '/products/clore-concentrate-mix-kit-30-gallons',
    '48035377414379': '/products/clore-concentrate-mix-kit-30-gallons'
  };

  var cloreKitImageOverrides = {
    '49043956138219': 'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/CopyofShopifyProductImages_1.png?v=1783906123',
    '48073524510955': 'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/CopyofShopifyProductImages_1.png?v=1783906123',
    '49287081066731': 'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/CopyofShopifyProductImages_1.png?v=1783906123',
    '49287081099499': 'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/CopyofShopifyProductImages_1.png?v=1783906123',
    '48039276708075': 'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/10.jpg?v=1786663592',
    '48039276740843': 'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/10.jpg?v=1786663592',
    '48039276773611': 'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/10.jpg?v=1786663592',
    '48039266648299': 'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/11.jpg?v=1786663592',
    '48039266681067': 'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/11.jpg?v=1786663592',
    '48039266713835': 'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/11.jpg?v=1786663592',
    '48035377348843': 'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/12.jpg?v=1786663592',
    '48035377381611': 'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/12.jpg?v=1786663592',
    '48035377414379': 'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/12.jpg?v=1786663592'
  };

  function cartItemImage(item){
    return item.image || cloreKitImageOverrides[String(item.variant_id)] || '';
  }

  function cartItemUrl(item){
    return cloreKitUrlOverrides[String(item.variant_id)] || item.url || '#';
  }

  var cloreVariantListedPrices = {
    '49043956138219': 34900,
    '48073524510955': 32900,
    '49287081066731': 32900,
    '49287081099499': 32900,
    '48039276708075': 59900,
    '48039276740843': 94900,
    '48039276773611': 59900,
    '48039266648299': 79900,
    '48039266681067': 114900,
    '48039266713835': 79900,
    '48035377348843': 94900,
    '48035377381611': 129900,
    '48035377414379': 94900
  };

  function cartLinePrice(item){
    var quantity = Math.max(1, Number(item.quantity) || 1);
    var listedUnit = cloreVariantListedPrices[String(item.variant_id)];
    var hasSellingPlan = !!(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan);
    if (hasSellingPlan) {
      if (listedUnit != null) return Math.round((listedUnit * 0.9) / 100) * 100 * quantity;
      if (item.final_line_price != null) return Math.round((Number(item.final_line_price) || 0) / 100) * 100;
    }
    if (listedUnit != null) return listedUnit * quantity;
    if (item.final_line_price != null) return Number(item.final_line_price) || 0;
    if (item.line_price != null) return Number(item.line_price) || 0;
    return 0;
  }

  function cartSubtotal(cart){
    return (cart.items || []).reduce(function(total, item){ return total + cartLinePrice(item); }, 0);
  }

  function renderCart(cart){
    if (!body) return;
    var count = Number(cart.item_count || 0);
    if (!count) {
      body.innerHTML = '<div class="clore-slide-cart__empty"><strong>Your cart is empty</strong><span>Add a defense kit to get started.</span></div>';
      if (subtotal) subtotal.textContent = money(0);
      forceCheckoutVisible(false);
      return;
    }
    body.innerHTML = (cart.items || []).map(function(item){
      var imageUrl = cartItemImage(item);
      var img = imageUrl ? '<img class="clore-slide-cart__item-image" src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(item.product_title || item.title || '') + '">' : '<div class="clore-slide-cart__item-image"></div>';
      var hasSellingPlan = !!(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan);
      var isGift = isManagedSubscriptionGift(item);
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="clore-slide-cart__item-variant">' + escapeHtml(item.variant_title) + '</p>' : '';
      var selling = '';
      var properties = renderProperties(item.properties);
      var quantity = isGift ? '<span class="clore-slide-cart__gift-badge">FREE SUBSCRIBER GIFT · QTY ' + item.quantity + '</span>' : '<div class="clore-slide-cart__qty"><button type="button" data-clore-cart-change="-1" aria-label="Decrease quantity">−</button><span>' + item.quantity + '</span><button type="button" data-clore-cart-change="1" aria-label="Increase quantity">+</button></div>';
      var remove = isGift ? '' : '<button type="button" class="clore-slide-cart__remove" data-clore-cart-remove>Remove</button>';
      return '<div class="clore-slide-cart__item' + (isGift ? ' clore-slide-cart__item--gift' : '') + '" data-clore-cart-key="' + escapeHtml(item.key) + '">' + img + '<div><a class="clore-slide-cart__item-title" href="' + escapeHtml(cartItemUrl(item)) + '">' + escapeHtml(item.product_title || item.title || 'Item') + '</a>' + variant + selling + properties + '<div class="clore-slide-cart__item-meta">' + quantity + '<div class="clore-slide-cart__line-price">' + money(cartLinePrice(item)) + '</div></div>' + remove + '</div></div>';
    }).join('');
    if (subtotal) subtotal.textContent = money(cartSubtotal(cart));
    drawer.setAttribute('data-clore-cart-item-count', String(count));
    forceCheckoutVisible(true);
  }

  function refreshCart(){
    if (body) body.innerHTML = '<div class="clore-slide-cart__loading">Loading cart...</div>';
    return fetchCart().then(reconcileSubscriptionGifts).then(renderCart).catch(function(err){
      if (body) body.innerHTML = '<div class="clore-slide-cart__empty"><strong>Cart could not load</strong><span>Please try again.</span></div>';
      forceCheckoutVisible(false);
      showNotice(err.message || 'Cart could not load.');
      throw err;
    });
  }

  function refreshCartUntilVariants(variantIds, previousCount, attempt){
    var expected = (variantIds || []).map(function(id){ return String(id); }).filter(Boolean);
    return fetchCart().then(function(cart){
      var count = Number(cart.item_count || 0);
      var present = {};
      (cart.items || []).forEach(function(item){ present[String(item.variant_id)] = true; });
      var hasAll = expected.every(function(id){ return present[id]; });
      if ((hasAll || count > Number(previousCount || 0)) || (attempt || 0) >= 6) {
        renderCart(cart);
        return cart;
      }
      return new Promise(function(resolve){ setTimeout(resolve, 250); }).then(function(){ return refreshCartUntilVariants(expected, previousCount, (attempt || 0) + 1); });
    }).catch(function(err){
      if ((attempt || 0) < 6) {
        return new Promise(function(resolve){ setTimeout(resolve, 250); }).then(function(){ return refreshCartUntilVariants(expected, previousCount, (attempt || 0) + 1); });
      }
      throw err;
    });
  }

  function refreshCartUntilVariant(variantId, previousCount, attempt){
    return refreshCartUntilVariants([variantId], previousCount, attempt);
  }

  function changeLine(key, quantity){
    return fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      credentials:'same-origin',
      body:JSON.stringify({id:key, quantity:Math.max(0, Number(quantity) || 0)})
    }).then(function(r){ if(!r.ok) return r.json().then(function(e){ throw new Error(e.description || 'Cart update failed'); }); return r.json(); })
      .then(reconcileSubscriptionGifts)
      .then(renderCart);
  }

  var cloreCartAddQueue = Promise.resolve();

  function postCartAdd(payload, attempt){
    return fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      credentials:'same-origin',
      cache:'no-store',
      body:JSON.stringify(payload)
    }).then(function(r){
      if(!r.ok) return r.json().catch(function(){ return {}; }).then(function(e){ throw new Error(e.description || 'Add to cart failed'); });
      return r.json();
    }).catch(function(err){
      if ((attempt || 0) < 1) {
        return new Promise(function(resolve){ setTimeout(resolve, 250); }).then(function(){ return postCartAdd(payload, (attempt || 0) + 1); });
      }
      throw err;
    });
  }

  function postCartAddItems(items, attempt){
    return postCartAdd({items:items}, attempt);
  }

  function postCartUpdate(updates){
    return fetch('/cart/update.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      credentials:'same-origin',
      cache:'no-store',
      body:JSON.stringify({updates:updates})
    }).then(function(r){
      if(!r.ok) return r.json().catch(function(){ return {}; }).then(function(e){ throw new Error(e.description || 'Cart update failed'); });
      return r.json();
    });
  }

  function variantSet(value){
    var variants = {};
    String(value || '').split(',').forEach(function(id){
      id = String(id || '').trim();
      if (id) variants[id] = true;
    });
    return variants;
  }

  var CLORE_SUBSCRIPTION_KIT_VARIANTS = {
    '49287081099499':'49287081066731',
    '48039276773611':'48039276708075',
    '48039266713835':'48039266648299',
    '48035377414379':'48035377348843'
  };

  var CLORE_SUBSCRIPTION_GIFT_RULES = [
    {
      variantId:String(drawer.getAttribute('data-clore-gift-variant-id') || '49286807355627').trim(),
      fallbackSellingPlanId:String(drawer.getAttribute('data-clore-gift-selling-plan-id') || '11642863851').trim(),
      triggerVariants:variantSet(drawer.getAttribute('data-clore-gift-trigger-variants') || '48039276773611,48039266713835,48035377414379'),
      propertyLabel:'New subscriber backpack sprayer'
    },
    {
      variantId:String(drawer.getAttribute('data-clore-hand-gift-variant-id') || '49286845628651').trim(),
      fallbackSellingPlanId:'',
      triggerVariants:variantSet(drawer.getAttribute('data-clore-hand-gift-trigger-variants') || '49287081099499'),
      propertyLabel:'New subscriber hand sprayer'
    }
  ].filter(function(rule){ return /^\d+$/.test(rule.variantId); });

  CLORE_SUBSCRIPTION_GIFT_RULES.forEach(function(rule){
    Object.keys(CLORE_SUBSCRIPTION_KIT_VARIANTS).forEach(function(noSprayerVariantId){
      var kitVariantId = CLORE_SUBSCRIPTION_KIT_VARIANTS[noSprayerVariantId];
      if (rule.triggerVariants[noSprayerVariantId] || rule.triggerVariants[kitVariantId]) {
        rule.triggerVariants[noSprayerVariantId] = true;
        rule.triggerVariants[kitVariantId] = true;
      }
    });
  });

  function giftRuleForParentVariant(id){
    id = String(id || '').trim();
    for (var i = 0; i < CLORE_SUBSCRIPTION_GIFT_RULES.length; i += 1) {
      if (CLORE_SUBSCRIPTION_GIFT_RULES[i].triggerVariants[id]) return CLORE_SUBSCRIPTION_GIFT_RULES[i];
    }
    return null;
  }

  function giftRuleForGiftVariant(id){
    id = String(id || '').trim();
    for (var i = 0; i < CLORE_SUBSCRIPTION_GIFT_RULES.length; i += 1) {
      if (CLORE_SUBSCRIPTION_GIFT_RULES[i].variantId === id) return CLORE_SUBSCRIPTION_GIFT_RULES[i];
    }
    return null;
  }

  function isEligibleSubscriptionItem(item){
    return !!item &&
      !!giftRuleForParentVariant(item.variant_id) &&
      !!(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan);
  }

  function isManagedSubscriptionGift(item){
    return !!item && !!giftRuleForGiftVariant(item.variant_id);
  }

  function giftParentVariant(item){
    return String(item && item.properties && item.properties['_Clore parent subscription variant'] || '').trim();
  }

  function giftSellingPlanRequired(error){
    return !!error && /selling plan/i.test(String(error.message || error));
  }

  function addGiftSellingPlan(items){
    return (items || []).map(function(item){
      var rule = giftRuleForGiftVariant(item.id);
      if (!rule || !rule.fallbackSellingPlanId) return item;
      var plannedGift = Object.assign({}, item);
      plannedGift.selling_plan = rule.fallbackSellingPlanId;
      return plannedGift;
    });
  }

  function postCartAddItemsWithGiftFallback(items){
    return postCartAddItems(items, 0).catch(function(error){
      var hasFallback = (items || []).some(function(item){
        var rule = giftRuleForGiftVariant(item.id);
        return !!(rule && rule.fallbackSellingPlanId);
      });
      if (!hasFallback || !giftSellingPlanRequired(error)) throw error;
      return postCartAddItems(addGiftSellingPlan(items), 0);
    });
  }

  // Keep one free sprayer per eligible subscription kit, even when a cart is
  // restored, a kit quantity changes, or an eligible kit is removed.
  function reconcileSubscriptionGifts(cart){
    cart = cart || {items:[]};
    if (!CLORE_SUBSCRIPTION_GIFT_RULES.length) return Promise.resolve(cart);

    var desiredByRuleParent = {};
    var giftsByRuleParent = {};
    var updates = {};
    var additions = [];

    (cart.items || []).forEach(function(item){
      if (isEligibleSubscriptionItem(item)) {
        var eligibleParent = String(item.variant_id);
        var eligibleRule = giftRuleForParentVariant(eligibleParent);
        var desiredKey = eligibleRule.variantId + ':' + eligibleParent;
        if (!desiredByRuleParent[desiredKey]) {
          desiredByRuleParent[desiredKey] = {rule:eligibleRule, parent:eligibleParent, quantity:0};
        }
        desiredByRuleParent[desiredKey].quantity += Math.max(1, Number(item.quantity) || 1);
      }
      if (isManagedSubscriptionGift(item)) {
        var managedRule = giftRuleForGiftVariant(item.variant_id);
        var giftParent = giftParentVariant(item);
        var giftKey = managedRule.variantId + ':' + giftParent;
        if (!giftsByRuleParent[giftKey]) giftsByRuleParent[giftKey] = [];
        giftsByRuleParent[giftKey].push(item);
      }
    });

    Object.keys(giftsByRuleParent).forEach(function(key){
      var lines = giftsByRuleParent[key];
      var desired = desiredByRuleParent[key] ? desiredByRuleParent[key].quantity : 0;
      if (!desired) {
        lines.forEach(function(line){ updates[line.key] = 0; });
        return;
      }
      if (Number(lines[0].quantity || 0) !== desired) updates[lines[0].key] = desired;
      lines.slice(1).forEach(function(line){ updates[line.key] = 0; });
    });

    Object.keys(desiredByRuleParent).forEach(function(key){
      var desired = desiredByRuleParent[key];
      if (giftsByRuleParent[key] && giftsByRuleParent[key].length) return;
      additions.push({
        id:desired.rule.variantId,
        quantity:desired.quantity,
        properties:{
          '_Clore gift':desired.rule.propertyLabel,
          '_Clore parent subscription variant':desired.parent
        }
      });
    });

    var updateKeys = Object.keys(updates);
    var result = updateKeys.length ? postCartUpdate(updates) : Promise.resolve(cart);
    return result.then(function(updatedCart){
      if (!additions.length) return updatedCart;
      return postCartAddItemsWithGiftFallback(additions).then(fetchCart);
    });
  }

  var CLORE_ONE_TIME_WITH_SPRAYER_BUNDLES = {
    '49287081066731': {kitVariantId:'49287081066731', sprayerVariantId:'49305644433643'},
    '48039276708075': {kitVariantId:'48039276708075', sprayerVariantId:'49305643876587'},
    '48039266648299': {kitVariantId:'48039266648299', sprayerVariantId:'49305643876587'},
    '48035377348843': {kitVariantId:'48035377348843', sprayerVariantId:'49305643876587'}
  };

  function addToCart(id, quantity, properties, sellingPlan){
    id = String(id || '').trim();
    var itemQuantity = Math.max(1, Number(quantity) || 1);
    var subscriptionKitVariantId = sellingPlan ? (CLORE_SUBSCRIPTION_KIT_VARIANTS[id] || id) : id;
    var oneTimeBundle = sellingPlan ? null : CLORE_ONE_TIME_WITH_SPRAYER_BUNDLES[id];
    var bundleId = oneTimeBundle ? ['clore-one-time', Date.now(), Math.random().toString(36).slice(2, 10)].join('-') : '';
    var kitProperties = Object.assign({}, properties || {});
    if (oneTimeBundle) {
      kitProperties['_Clore one-time bundle'] = bundleId;
      kitProperties['_Clore bundle role'] = 'kit';
      kitProperties['_Clore sprayer variant'] = oneTimeBundle.sprayerVariantId;
      kitProperties['Purchase option'] = 'One-Time Purchase';
    }
    var payload = {id:oneTimeBundle ? oneTimeBundle.kitVariantId : subscriptionKitVariantId, quantity:itemQuantity};
    if (!payload.id || !/^\d+$/.test(payload.id)) return Promise.reject(new Error('Missing product variant.'));
    if (Object.keys(kitProperties).length) payload.properties = kitProperties;
    if (sellingPlan) payload.selling_plan = sellingPlan;
    var giftRule = sellingPlan ? giftRuleForParentVariant(payload.id) : null;
    var giftPayload = giftRule ? {
      id:giftRule.variantId,
      quantity:itemQuantity,
      properties:{
        '_Clore gift':giftRule.propertyLabel,
        '_Clore parent subscription variant':payload.id
      }
    } : null;
    var oneTimeBundlePayloads = oneTimeBundle ? [payload, {
      id:oneTimeBundle.sprayerVariantId,
      quantity:itemQuantity,
      properties:{
        '_Clore one-time bundle':bundleId,
        '_Clore bundle role':'sprayer',
        '_Clore parent kit variant':oneTimeBundle.kitVariantId
      }
    }] : null;
    var run = function(){
      openDrawer({loading:true, hasItems:true});
      return (oneTimeBundlePayloads ? postCartAddItems(oneTimeBundlePayloads, 0) : (giftPayload ? postCartAddItemsWithGiftFallback([payload, giftPayload]) : postCartAdd(payload, 0)))
        .then(function(){
          document.dispatchEvent(new CustomEvent('clore:cart-add-confirmed',{detail:{properties:kitProperties,requestId:'cart:'+Date.now()+':'+Math.random().toString(36).slice(2)}}));
          return fetchCart();
        })
        .then(reconcileSubscriptionGifts)
        .then(function(cart){ renderCart(cart); return cart; })
        .catch(function(err){
          showNotice((err && err.message) || 'Could not add item.');
          return refreshCart().catch(function(){ throw err; });
        });
    };
    cloreCartAddQueue = cloreCartAddQueue.then(run, run);
    return cloreCartAddQueue;
  }
  window.CloreSlideCartAddToCart = addToCart;

  function renderProperties(properties){
    if (!properties) return '';
    var rows = [];
    Object.keys(properties).forEach(function(key){
      var value = properties[key];
      if (!value || key.charAt(0) === '_') return;
      rows.push('<li><strong>' + escapeHtml(key) + ':</strong> ' + escapeHtml(decodeHtmlEntities(value)) + '</li>');
    });
    return rows.length ? '<ul class="clore-slide-cart__item-properties">' + rows.join('') + '</ul>' : '';
  }

  function decodeHtmlEntities(value){
    return String(value == null ? '' : value)
      .replace(/&amp;/g, '&')
      .replace(/&#39;/g, "'")
      .replace(/&quot;/g, '"')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>');
  }

  function escapeHtml(value){
    return String(value == null ? '' : value).replace(/[&<>"]/g, function(ch){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[ch]; });
  }

  function parseCartPermalink(href){
    if (!href) return null;
    var raw = String(href);
    try {
      var parsedUrl = new URL(raw, window.location.origin);
      var id = parsedUrl.searchParams.get('id');
      if (parsedUrl.pathname === '/cart/add' && id) {
        return {id:id, quantity:parsedUrl.searchParams.get('quantity') || 1};
      }
      var pathMatch = parsedUrl.pathname.match(/^\/cart\/(\d+)(?::(\d+))?/);
      if (pathMatch) return {id:pathMatch[1], quantity:pathMatch[2] || 1};
    } catch(err) {}
    var addMatch = raw.match(/\/cart\/add\?[^#]*[?&]id=(\d+)/);
    if (addMatch) {
      var qtyMatch = raw.match(/[?&]quantity=(\d+)/);
      return {id:addMatch[1], quantity:qtyMatch ? qtyMatch[1] : 1};
    }
    var match = raw.match(/\/cart\/(\d+)(?::(\d+))?/);
    if (!match) return null;
    return {id:match[1], quantity:match[2] || 1};
  }

  function trackInitiateCheckout(cart){
    var payload = {
      event: 'InitiateCheckout',
      ecommerce: {
        currency: cart.currency || 'USD',
        value: (Number(cart.total_price || 0) / 100),
        items: (cart.items || []).map(function(item){
          return {
            item_id: item.variant_id,
            item_name: item.product_title || item.title,
            variant: item.variant_title,
            quantity: item.quantity,
            price: Number(item.final_price || item.price || 0) / 100
          };
        })
      }
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'InitiateCheckout', {
        value: payload.ecommerce.value,
        currency: payload.ecommerce.currency,
        content_ids: payload.ecommerce.items.map(function(item){ return String(item.item_id); }),
        contents: payload.ecommerce.items.map(function(item){ return {id:String(item.item_id), quantity:item.quantity}; }),
        num_items: payload.ecommerce.items.reduce(function(total, item){ return total + Number(item.quantity || 0); }, 0)
      });
    }
    document.dispatchEvent(new CustomEvent('clore:cart:initiate_checkout', {detail: payload}));
  }

  function checkoutUrl(){
    return new URL('/checkout', window.location.origin).toString();
  }

  function goToCheckout(){
    var url = checkoutUrl();
    if (checkout) {
      checkout.setAttribute('href', url);
      checkout.setAttribute('target', '_self');
    }
    window.location.assign(url);
  }

  function trackCheckoutFromClick(){
    fetchCart().then(trackInitiateCheckout).catch(function(){});
  }

  function initiateCheckout(){
    return fetchCart().then(reconcileSubscriptionGifts).then(function(cart){
      if (!cart || !Number(cart.item_count || 0)) {
        openDrawer();
        renderCart(cart || {item_count:0, items:[], total_price:0});
        forceCheckoutVisible(false);
        throw new Error('Your cart is empty.');
      }
      renderCart(cart);
      trackInitiateCheckout(cart);
      forceCheckoutVisible(true);
      goToCheckout();
    }).catch(function(err){
      if (err && err.message === 'Your cart is empty.') showNotice(err.message);
      else {
        openDrawer();
        showNotice('Your cart could not be verified. Please try checkout again.');
        refreshCart().catch(function(){});
      }
    });
  }

  drawer.addEventListener('click', function(e){
    if (e.target.closest('[data-clore-cart-checkout]')) {
      e.preventDefault();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      initiateCheckout();
      return;
    }
    if (e.target.closest('[data-clore-cart-close]')) closeDrawer();
    var line = e.target.closest('[data-clore-cart-key]');
    if (!line) return;
    var key = line.getAttribute('data-clore-cart-key');
    var qtyText = line.querySelector('.clore-slide-cart__qty span');
    var currentQty = qtyText ? Number(qtyText.textContent) || 1 : 1;
    var changeBtn = e.target.closest('[data-clore-cart-change]');
    if (changeBtn) changeLine(key, currentQty + Number(changeBtn.getAttribute('data-clore-cart-change')));
    if (e.target.closest('[data-clore-cart-remove]')) changeLine(key, 0);
  });

  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });

  document.addEventListener('click', function(e){
    var openCartTrigger = e.target.closest('[data-clore-open-cart]');
    if (openCartTrigger && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey) {
      e.preventDefault();
      openDrawer({loading:true});
      refreshCart();
      return;
    }

    var checkoutLink = e.target.closest('a[href="/checkout"], a[href^="/checkout?"]');
    if (checkoutLink && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey) {
      e.preventDefault();
      e.stopPropagation();
      initiateCheckout();
      return;
    }

    var cartLink = e.target.closest('a[href="/cart"], a[href$="/cart"]');
    if (cartLink && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey) {
      e.preventDefault();
      openDrawer({loading:true});
      refreshCart();
      return;
    }

    var addLink = e.target.closest('a.clore-checkout-link, a[href*="/cart/add"], a[href*="/cart/"][href*="checkout"]');
    if (!addLink || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var parsed = parseCartPermalink(addLink.getAttribute('href'));
    var card = addLink.closest('.clore-product-card');
    if (!parsed && card && card.getAttribute('data-variant')) parsed = {id:card.getAttribute('data-variant'), quantity:1};
    if (!parsed) return;
    e.preventDefault();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    addLink.setAttribute('aria-busy', 'true');
    addToCart(parsed.id, parsed.quantity).catch(function(err){ showNotice(err.message || 'Could not add item.'); }).finally(function(){ addLink.removeAttribute('aria-busy'); });
  }, true);


  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    var props = {};
    fd.forEach(function(value, key){
      var propMatch = key.match(/^properties\[(.+)\]$/);
      if (propMatch && value) props[propMatch[1]] = value;
    });
    addToCart(fd.get('id'), fd.get('quantity') || 1, props, fd.get('selling_plan')).catch(function(err){ showNotice(err.message || 'Could not add item.'); });
  }, true);

  if (window.location.search && new URLSearchParams(window.location.search).get('openCart') === '1') {
    refreshCart().then(openDrawer).finally(function(){
      if (window.history && window.history.replaceState) window.history.replaceState({}, document.title, window.location.pathname || '/');
    });
  }
})();
